import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { MultiSelectOption, SelectOption } from '@rtkwlf/fenrir-react';
import { Field, TextField, VStack } from '@rtkwlf/fenrir-react';
import { faSearch } from '@rtkwlf/pro-solid-svg-icons/faSearch';
import { useTranslation } from 'react-i18next';

type SearchInputProps = {
  value: string;
  field?: string | undefined;
  title?: string | undefined;
  handleChange: (
    field: string,
    changes: SelectOption | MultiSelectOption[] | null,
    isSingleSelect?: boolean,
    searchInputValue?: string,
  ) => void;
  labelPaddingBottom?: 'zero' | 'small';
};

export const SearchInput: React.FC<SearchInputProps> = ({
  value,
  field = '',
  title = '',
  handleChange,
  labelPaddingBottom = 'zero',
}) => {
  const { t } = useTranslation();

  return (
    <VStack zIndex={0} justifyContent="flex-start">
      <Field.Root>
        <Field.Label paddingBottom={labelPaddingBottom}>
          {title || t('components:filter.search')}
        </Field.Label>
        <Field.Content>
          <TextField
            value={value}
            onChange={(e) => {
              handleChange(
                field || '',
                {} as SelectOption,
                false,
                (e.target as HTMLInputElement).value,
              );
            }}
            type="text"
            placeholder={t('components:filter.placeholder.search')}
            fontSize="default"
            fontWeight="normal"
            iconRight={<FontAwesomeIcon icon={faSearch} />}
          />
        </Field.Content>
      </Field.Root>
    </VStack>
  );
};
